import Icon from "@ant-design/icons";
import { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const ShoppingFavouriteSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M11.5 21H8.574a3 3 0 0 1-2.965-2.544l-1.255-8.152A2 2 0 0 1 6.331 8H17.67a2 2 0 0 1 1.977 2.304q-.086.552-.127.828"></path>
      <path d="M9 11V6a3 3 0 0 1 6 0v5m3 11l3.35-3.284a2.143 2.143 0 0 0 .005-3.071a2.24 2.24 0 0 0-3.129-.006l-.224.22l-.223-.22a2.24 2.24 0 0 0-3.128-.006a2.143 2.143 0 0 0-.006 3.071z"></path>
    </g>
  </svg>
);
const ShoppingFavouriteIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShoppingFavouriteSvg} {...props} />
);
export default ShoppingFavouriteIcon;
